import { useContext } from "react";
import ConfirmContext from 'store/SnackbarContext';
import { SHOW_SNACKBAR, HIDE_SNACKBAR } from  'store/snackbarReducer';


let resolveCallback;
function useSnackbar() {
    const [snackbarState, dispatch] = useContext(ConfirmContext);

    const onClose = () => {
        closeSnackbar();
        resolveCallback(true);
    };

    const snackbar = ({message, severity = "success", duration = 2000}) => {
        dispatch({
            type: SHOW_SNACKBAR,
            payload: {
                message,
                severity,
                duration
            }
        });
        return new Promise((res, rej) => {
            resolveCallback = res;
        });
    };

    const closeSnackbar = () => {
        dispatch({
            type: HIDE_SNACKBAR
        });
    };


    return { snackbar, snackbarState, onClose}

}

export default useSnackbar;